<template>
<div class="map-ui-container">
  <div class="map-ui-controls">
    <div class="mapboxgl-ctrl">
      <button @click="$emit('zoom', 'in')">
        <v-icon color="#2A2929">mdi-magnify-plus-outline</v-icon>
      </button>
    </div>

    <div class="mapboxgl-ctrl">
      <button @click="$emit('zoom', 'out')">
        <v-icon color="#2A2929">mdi-magnify-minus-outline</v-icon>
      </button>
    </div>

    <div class="mapboxgl-ctrl">
      <button  @click="$emit('zoom', 'reset')">
        <v-icon color="#2A2929">mdi-refresh</v-icon>
      </button>       
    </div>    
  </div>

  <!-- <div class="map-ui-legend-button" v-if="$vuetify.breakpoint.smAndDown">
    <div class="mapboxgl-ctrl">
      <button @click="showLegend = !showLegend">
        <v-icon color="#2A2929">mdi-information-outline</v-icon>
      </button>       
    </div>
  </div>   -->

  <!-- <transition name="fade">
    <div class="map-ui-legend-box" v-show="showLegend">
      <div class="mapboxgl-ctrl">
        <p class="mb-3 text--caption font-weight-bold">Legend</p>

        <div v-if="!$vuetify.breakpoint.smAndDown">
          <p v-for="n in legend" :key="n.color" class="text--caption mb-2"><span class="legend-circle mr-2" :style="{backgroundColor: n.color}" />{{ n.label }}</p>      
        </div>

        <v-row no-gutters style="max-width: 350px" v-if="$vuetify.breakpoint.smAndDown">
          <v-col :cols="n.cols" v-for="n in legendMobile" :key="n.color">
            <p class="text--caption mb-2"><span class="legend-circle mr-2" :style="{backgroundColor: n.color}" />{{ n.label }}</p>            
          </v-col>
        </v-row>
      </div>
    </div>    
  </transition> -->

  <div :class="mapInstructionClasses">
    <p class="text--caption text-center text--fes-blue mb-0">
      {{ this.$vuetify.breakpoint.mdAndUp ? 'Click' : 'Tap' }} on an icon to start exploring
    </p>
  </div>  

  <div class="map-ui-tooltip">
    <p class="text--caption mb-0">
      {{ tooltipUI }}
    </p>
  </div>    
</div>
</template>

<script>
export default {
  name: 'MapUI', 
  computed: {
    mapInstructionClasses() {
      return {
        'map-ui-instruction --desktop': this.$vuetify.breakpoint.mdAndUp,
        'map-ui-instruction --mobile': this.$vuetify.breakpoint.smAndDown,
      };
    },
  },
  data() {
    return {
      tooltipUI: '',
      legend: [       
        { color: '#E9DAF0', label: 'Community'},
        { color: '#E3E70A', label: 'Enterprise'},
        { color: '#F2BB47', label: 'Family farm'},
        { color: '#BBCCE8', label: 'Individual'},
        { color: '#FBC7B5', label: 'Non-profit organisation'},
        { color: '#8AD3AF', label: 'Organisation'},
        { color: '#E2D291', label: 'Permaculture Research Institute'},
      ],
      legendMobile: [       
        { color: '#E9DAF0', label: 'Community', cols: 4 },
        { color: '#FBC7B5', label: 'Non-profit organisation', cols: 8},
        { color: '#E3E70A', label: 'Enterprise', cols: 4},
        { color: '#8AD3AF', label: 'Organisation', cols: 8},
        { color: '#F2BB47', label: 'Family farm', cols: 4},
        { color: '#E2D291', label: 'Permaculture Research Institute', cols: 8},
        { color: '#BBCCE8', label: 'Individual', cols: 4},
      ],      
      showLegend: true,
    }
  },
  methods: {
    showTooltip(content, target) {
      this.tooltipUI = content;
      const top = target.getBoundingClientRect().top - 4; // minus 4 coz of box margin
      document.querySelector('.map-ui-tooltip').style.display = 'block';
      document.querySelector('.map-ui-tooltip').style.top = top + 'px';

      setTimeout(function() { 
        document.querySelector('.map-ui-tooltip').style.display = 'none'
      }, 5000);      
    },   
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/settings/_variables.scss';

.map-ui-controls {
  position: absolute;
  top: calc(32px);
  right: 32px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    right: 16px;
    top: calc(69px + 20px + 56px);
  }    
  .mapboxgl-ctrl {
    border-radius: unset !important;
    background-color: rgba(250, 247, 245, 0.9);
    margin-bottom: 4px;
    padding: 2px;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      margin-bottom: 12px;
    }        
  }
}

.map-ui-legend-box {
  position: absolute;
  bottom: 24px;
  right: 32px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    right: 16px;
    left: 16px;
    bottom: 116px;
  }    

  .mapboxgl-ctrl {
    border-radius: 4px;
    background-color:  rgba(250, 247, 245, 0.9);
    padding: 16px;
    margin-bottom: 4px;
    .legend-circle {
      width: 18px;
      height: 18px;
      display: inline-block;
      vertical-align: bottom;
      border-radius: 50%;      
    }    
  }
}

.map-ui-legend-button {
  position: absolute;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    right: 16px;
    bottom: 84px;
  }    
  .mapboxgl-ctrl {
    border-radius: unset !important;
    background-color: rgba(250, 247, 245, 0.9);
    padding: 2px;
  }
}

.map-ui-instruction {
  position: absolute;
  background-color: #FAF7F5;
  border-radius: 8px;
   
  p {
    display: inline-block;
  }

  img {
    vertical-align: middle;
  }

  &.--desktop {
    bottom: 24px;
    transform: translate(-50%, 0); 
    left: 50%;
    padding: 8px;
  }

  &.--mobile {
    top: calc(36px);
    left: 50%;
    transform: translate(-50%, 0); 
    padding: 8px;
    width: calc(100vw - 16px - 16px);
    display: flex;
    justify-content: center;    
  }  
}

.map-ui-tooltip {
  position: absolute;
  top: calc(69px + 32px);
  right: 72px;  
  padding: 12px;
  color: rgba(250, 247, 245, 0.9);
  background-color: #FAF7F5;
  display: none;
}

.map-ui-tooltip:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 8px solid #FAF7F5;
  border-right: 8px solid transparent;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  right: -16px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
